<template>
  <div>
    <v-dialog v-model="dialog.discount" 
      persistent
      width="750">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5">
          Detail Diskon Booking Unit
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="250">Judul</th>
                  <th class="text-left">Keterangan</th>
                  <th class="text-right">Diskon</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(item, index) in  booking.transaction_discount_detail" 
                  :key="index">
                  <td class="text-second">
                    {{ item.title }}
                  </td>
                  <td class="caption text-second">
                    <span v-html="item.desc"></span>
                  </td>
                  <td class="caption text-second text-right">
                    {{ parseInt(item.price) | price }}
                  </td>
                </tr>
                <tr>
                  <td class="subtitle-2 text-first">
                    Total Diskon
                  </td>
                  <td></td>
                  <td class="subtitle-2 text-first text-right">
                    {{ parseInt(booking.transaction_discount_value) | price }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            color="red"
            class="text-capitalize"
            @click="dialog.discount = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.bank" 
      persistent
      width="400">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5">
          Ubah Bank KPR
        </v-card-title>
        <v-card-text class="pt-5">
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <ValidationProvider name="Bank KPR" rules="required" v-slot="{ errors }">
                <v-select
                  dense
                  outlined
                  single-line
                  label="Bank KPR"
                  :color="style.primary"
                  :items="bank"
                  item-value="ref_bank_kpr_bank_id"
                  item-text="ref_bank_kpr_bank_name"
                  item-color="light-green lighten-2"
                  v-model="form.bank_kpr"
                  :error-messages="errors"
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                  <template v-slot:selection="data">
                    <v-avatar left tile class="mr-2" size="40">
                      <v-img contain :src="data.item.ref_bank_kpr_bank_image"></v-img>
                    </v-avatar>
                    <span class="contain">
                      {{ data.item.ref_bank_kpr_bank_name }}
                    </span>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile size="40">
                        <v-img contain :src="data.item.ref_bank_kpr_bank_image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="caption" v-html="data.item.ref_bank_kpr_bank_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </ValidationProvider>

              <v-text-field
                dense
                outlined
                label="Cabang Bank KPR (bisa dikosongi)"
                :color="style.primary"
                hide-details
                v-model="form.bank_kpr_branch">
              </v-text-field>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-divider/>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="py-3 px-6">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="saveBank">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :disabled="process.run"
            @click="dialog.bank = false">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.approval" 
      persistent
      width="650">
      <v-card class="border-radius box-shadow">
        <v-card-title class="pb-0">
          <v-btn
            small
            outlined
            color="green"
            class="text-capitalize mr-2"
            @click="addDiscount()">
            Tambahkan Diskon
          </v-btn>
          <v-btn
            v-if="discount.price_discount.length > 0"
            small
            outlined
            color="red"
            class="text-capitalize"
            @click="discount.price_discount = []; discount.discount_value = 0;">
            Hapus Semua
          </v-btn>
        </v-card-title>
        <v-divider class="mt-5 mb-2" v-if="discount.price_discount.length > 0"/>
        <v-card-title class="py-0" v-if="discount.price_discount.length > 0">
          <v-row
            v-for="(item, index) in discount.price_discount"
            :key="index">
            <v-col cols="1">
              <div style="width: 32px;">
                <v-chip
                  class="px-0 d-flex justify-center align-center"
                  style="width: 100px; border-radius: 0px !important;"
                  label>
                  {{ index+1 }}
                </v-chip>
                <v-chip
                  style="border-radius: 0px !important;"
                  label
                  color="red"
                  class="px-1 text-center cursor-pointer"
                  @click="removeDiscount(index)">
                  <v-icon color="white">mdi-close</v-icon>
                </v-chip>
              </div>
            </v-col>
            <v-col cols="11">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Judul"
                    :color="style.primary"
                    prepend-inner-icon="mdi-text"
                    v-model="item.title">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-currency-field 
                    dense
                    outlined
                    label="Diskon"
                   :color="style.primary"
                    prepend-inner-icon="mdi-cash-100"
                    v-model="item.price">
                  </v-currency-field>
                </v-col>
              </v-row>

              <v-textarea
                clearable
                clear-icon="mdi-cancel"
                :color="style.primary"
                label="Keterangan"
                auto-grow
                outlined
                row-height="10"
                v-model="item.desc">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0" v-if="discount.price_discount.length < 1">
          <v-divider class="my-6"/>
          <p class="body-2 text-second text-center my-16">
            Belum ada Diskon
          </p>
          <v-divider class="my-6"/>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.run"
            :loading="process.run"
            @click="saveDiscount();">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            small
            color="red"
            class="text-capitalize red--text"
            :disabled="process.run"
            @click="calculate(); dialog.approval = false;">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card
          flat>
          <div style="background: var(--color-primary)">
            <v-card-title class="subtitle-2 white--text">
              Booking
            </v-card-title>
            <v-card-subtitle class="white--text caption line-text-first pt-2">
              Jika pembeli / konsumen sudah melakukan pembayaran. Maka anda dapat mengubah status pada pilihan belum terbayar menjadi terbayar. Lalu tekan tombol simpan perubahan.
            </v-card-subtitle>
          </div>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="12" md="6">
                <p>
                  <v-icon class="mr-1">mdi-cash-100</v-icon>
                  Nominal <b>{{ form.price | price }}</b>
                </p>
                <!-- <p>
                  <v-icon class="mr-1">mdi-calendar-month</v-icon>
                  Jatuh Tempo {{ form.duedate | date }}
                </p> -->
                <p>
                  <v-icon class="mr-1">mdi-calendar-month</v-icon>
                  <span v-if="form.paydate.length < 1">
                    -
                  </span>
                  <span v-else>
                    Tanggal Bayar {{ form.paydate | date }}
                  </span>
                </p>
                <p>
                  <v-icon class="mr-2">mdi-table-of-contents</v-icon>
                  <span v-html="form.desc.length > 0 ? form.desc : '-'"></span>
                </p>
                <p>
                  <v-icon>mdi-ticket-percent-outline</v-icon>
                  <span class="mx-2">
                    Diskon Booking Unit <b>{{ parseInt(booking.transaction_discount_value) | price }}</b>
                  </span>
                  <v-tooltip right v-if="booking.transaction_status_discount_review === '0'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pb-1"
                        :color="style.primary"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.discount = true">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Lihat Diskon</span>
                  </v-tooltip>
                  <v-tooltip right v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor')) && booking.transaction_status_discount_review === '1' && booking.company_project_is_active === '1'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pb-1"
                        :color="style.primary"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.approval = true">
                        mdi-pencil-circle-outline
                      </v-icon>
                    </template>
                    <span>Ubah Diskon / Konfirmasi Diskon</span>
                  </v-tooltip>
                </p>
                <p v-if="booking.transaction_payment_type === 'KPR'">
                  <v-icon>mdi-bank</v-icon>
                  <span class="mx-2">
                    KPR <b>{{ booking.place_order_kpr_bank_name }}</b> cabang <b>{{ booking.place_order_kpr_bank_branch }}</b>
                  </span>
                  <v-tooltip right v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && booking.company_project_is_active === '1'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pb-1"
                        :color="style.primary"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.bank = true; form.bank_kpr = booking.place_order_kpr_bank_id; form.bank_kpr_branch = booking.place_order_kpr_bank_branch;">
                        mdi-pencil-circle-outline
                      </v-icon>
                    </template>
                    <span>Ubah Bank KPR</span>
                  </v-tooltip>
                </p>
              </v-col>
              <v-col cols="12" md="6" class="text-right">
                <p class="teal--text font-weight-bold" v-if="form.status === 'close'">
                  <v-icon small class="mr-1" color="teal">mdi-check</v-icon>
                  Sudah Terbayar
                </p>
              </v-col>
            </v-row>
            
            <!-- <v-row>
              <v-col cols="12" md="6">
                <ValidationObserver ref="observer">
                  <v-form>
                    <ValidationProvider name="Harga" rules="required" v-slot="{ errors }">
                      <v-currency-field 
                        dense
                        outlined
                        label="Harga"
                        color="#4FC3F7"
                        prepend-inner-icon="mdi-cash-100"
                        v-model="form.price"
                        :error-messages="errors"
                        require>
                      </v-currency-field>
                    </ValidationProvider>
                    <v-menu
                      ref="tempo"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.tempo">
                      <template v-slot:activator="{ on }">
                        <ValidationProvider name="Jatuh Tempo" rules="required" v-slot="{ errors }">
                          <v-text-field
                            dense
                            outlined
                            readonly
                            color="#4FC3F7"
                            prepend-inner-icon="mdi-calendar-month"
                            label="Jatuh Tempo"
                            v-model="form.duedate"
                            v-on="on"
                            :error-messages="errors"
                            require>
                          </v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker 
                        color="#4FC3F7"
                        v-model="form.duedate"
                        @input="picker.tempo = false">
                      </v-date-picker>
                    </v-menu>
                    <v-menu
                      ref="buy"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.buy">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          color="#4FC3F7"
                          prepend-inner-icon="mdi-calendar-month"
                          label="Tanggal Bayar"
                          v-model="form.paydate"
                          v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker 
                        color="#4FC3F7"
                        v-model="form.paydate"
                        @input="picker.buy = false">
                      </v-date-picker>
                    </v-menu>
                  </v-form>
                </ValidationObserver>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  outlined
                  clearable
                  clear-icon="mdi-cancel"
                  color="#4FC3F7"
                  label="Keterangan"
                  auto-grow
                  row-height="32.3"
                  v-model="form.desc">
                </v-textarea>
              </v-col>
            </v-row>
            <v-alert type="error" text dense prominent 
              v-show="error.message.length > 0"
              v-html="error.message">
            </v-alert>
            <v-btn
              v-if="form.status === 'open'"
              outlined
              color="#4FC3F7"
              class="text-capitalize"
              :loading="process.run"
              :disabled="process.run"
              @click="save">
              <v-icon small class="mr-1">mdi-check</v-icon>
              Simpan Perubahan
            </v-btn>
            <p class="teal--text font-weight-bold" v-if="form.status === 'close'">
              <v-icon small class="mr-1" color="teal">mdi-check</v-icon>
              Sudah Terbayar
            </p> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import moment from 'moment';
  export default {
    data () {
      return {
        dialog: {
          discount: false,
          bank: false,
          approval: false
        },
        picker: {
          tempo: false,
          buy: false
        },
        add: false,
        bank: [],
        form: {
          booking_id: '',
          price: '',
          duedate: '',
          paydate: '',
          status: '',
          desc: '',

          // BANK KPR
          bank_kpr: '',
          bank_kpr_branch: ''
        },
        discount: {
          discount_value: 0, // DISKON
          price_discount: [{
            id: 0,
            title: '',
            price: 0,
            desc: ''
          }]
        },
        process: {
          run: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    props: [
      'booking'
    ],
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch() {
        await get(`auth/transaction/cash-tempo/booking/detail`, {
          params: {
            booking_id: this.$route.params.id
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            let item = res.data
            
            this.form = {
              booking_id: item.cash_tempo_id,
              price: parseInt(item.cash_tempo_value),
              duedate: item.cash_tempo_due_date,
              paydate: item.cash_tempo_closing_datetime.length > 0 ? moment(item.cash_tempo_closing_datetime).format('Y-MM-DD') : '',
              status: item.cash_tempo_status,
              desc: item.cash_tempo_desc,

              // BANK KPR
              bank_kpr: '',
              bank_kpr_branch: ''
            }

            this.discount.price_discount = this.booking.transaction_discount_detail
            this.discount.discount_value = parseInt(this.booking.transaction_discount_value)

            this.fetchBank()
          }
        })
      },
      async fetchBank() {
        await get(`auth/company/bank-kpr/list-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.bank = res.data.results
          }
        })
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.run = true
          await post(`auth/transaction/cash-tempo/booking/update`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              window.location = `/project/unit/transaction/booking/${this.$route.params.id}?transaction=${this.$route.query.transaction}&unit=${this.$route.query.unit}`
            } else {
              this.process.run = false
              this.error.message = res.msg
            }
          })
        }
      },
      async saveBank() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.run = true

          await post(`auth/sales/place-order/update-bank-kpr`, {
            data: {
              place_order_id: this.booking.place_order_id,
              bank_kpr: this.form.bank_kpr,
              bank_kpr_branch: this.form.bank_kpr_branch
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              window.location = `/project/unit/transaction/booking/${this.$route.params.id}?transaction=${this.$route.query.transaction}&unit=${this.$route.query.unit}`
            } else {
              this.process.run = false
              this.error.message = res.msg
            }
          })
        }
      },
      addDiscount() {
        this.discount.price_discount.push({
          id: 0,
          title: '',
          price: 0,
          desc: ''
        })
      },
      removeDiscount(index) {
        this.discount.price_discount.splice(index, 1)
      },
      calculate() {
        let total = this.discount.price_discount.reduce( ( sum, { price } ) => sum + price , 0)

        this.discount.discount_value = total
      },
      async saveDiscount() {
        this.error.message = ''
        this.process.run = true

        this.calculate()

        await post(`auth/transaction/update-and-approve-discount`, {
          data: {
            transaction_id: this.booking.transaction_id,
            discount_value: this.discount.discount_value,
            price_discount: JSON.stringify(this.discount.price_discount)
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            window.location = `/project/detail/${this.booking.project_id}`
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>